import { render } from "./SenderTable.vue?vue&type=template&id=0e5cf8db"
import script from "./SenderTable.vue?vue&type=script&lang=js"
export * from "./SenderTable.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__